import React from 'react';
import { ReactSVG } from 'react-svg';

const CustomSVG = React.memo(({ src, fill, height, stroke, width, stopColor }) => {
    return (
        <ReactSVG
            src={src}
            beforeInjection={(svg) => {
                if (fill) {
                    svg.setAttribute('fill', fill);
                }
                if (stroke) {
                    svg.setAttribute('stroke', stroke);
                }
                if (height) {
                    svg.setAttribute('height', height);
                }
                if (width) {
                    svg.setAttribute('width', width);
                }
                if (stopColor) {
                    const stops = svg.querySelectorAll('stop');
                    stops.forEach((stop) => {
                        stop.setAttribute('stop-color', stopColor);
                    });
                }
            }}
        />
    );
});

export default CustomSVG;
